(function () {
    "use strict";
    angular.module("app.core").directive("ngVisible", [
        function () {
            function link(scope, element, attrs) {
                var oldValue = false;
                function init() {
                    var elem = element[0];
                    var offsetWidth = elem.offsetWidth;
                    var newValue = offsetWidth != 0;
                    if (newValue && !oldValue) {
                        scope.$eval(attrs.ngVisible);
                    }
                    oldValue = newValue;
                }
                init();
                window.addEventListener("resize", init);
            }
            return {
                link: link,
            };
        },
    ]);
})();
